<template>
    <div>
        <site-header></site-header>
        <div class="c-t-search">
            <div class="c-t-search__header">
                <search-header
                    :title="title"
                    @reset="$router.push({ name: 'Sök hantverkare' })"
                ></search-header>
            </div>

            <div class="c-t-search__main-wrap">
                <div class="c-t-search__sidebar">
                    <label class="c-t-search__sub-heading"
                        >Filtrera hantverkare efter:</label
                    >
                    <search-sidebar
                        ref="searchSidebarRef"
                        :category="searchParams.category"
                        :region="searchParams.region"
                        :paramRegion="paramRegion"
                    ></search-sidebar>
                </div>
                <div class="c-t-search__main">
                    <label class="c-t-search__sub-heading"
                        >Hantverkare som matchar ditt urval:</label
                    >
                    <search-results></search-results>
                </div>
            </div>
        </div>
        <site-footer></site-footer>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {
    FETCH_COMPANIES,
    SET_REGION_ACTION,
    SET_CATEGORY_ACTION,
    SET_QUERY_ACTION,
    GET_SEARCH_PARAMS,
    GET_REGION,
    GET_CATEGORY,
    GET_FACET_TITLE,
    GET_FACET_CONTENT,
    GET_FACET_FULL_CONTENT
} from "../store/store-models/companies-model";
import {
    FETCH_FILTERS,
    GET_CATEGORY_BY_NAME,
    GET_REGION_BY_NAME
} from "../store/store-models/filters-model";

import SiteHeader from "./components/organisms/OrganismSiteHeader.vue";
import SiteFooter from "./components/organisms/OrganismSiteFooter.vue";
import SearchHeader from "./components/organisms/search/OrganismSearchHeaderCompanies.vue";
import SearchResults from "./components/organisms/search/OrganismSearchResultsCompanies.vue";
import SearchSidebar from "./components/organisms/search/OrganismSearchSidebarCompanies.vue";
import ButtonAtom from "./components/atoms/AtomButton.vue";
import Pagination from "./components/molecules/MoleculePagination.vue";

const setFacetsFromURL = async (store, router) => {
    try {
        const query = router.query && router.query.q ? router.query.q : null;
        await store.dispatch(SET_QUERY_ACTION, query);

        await store.dispatch(FETCH_FILTERS);

        let region = null;
        if (router.params.region && router.params.region !== "alla") {
            region = store.getters[GET_REGION_BY_NAME](router.params.region);
        }

        await store.dispatch(SET_REGION_ACTION, region);

        let category = null;
        if (router.params.category) {
            category = store.getters[GET_CATEGORY_BY_NAME](
                router.params.category
            );
        }

        await store.dispatch(SET_CATEGORY_ACTION, category);

        return store.dispatch(FETCH_COMPANIES);
    } catch (e) {
        console.log("setFacetsFromURL", e);
    }
};

export default {
    async asyncData({ store, route }) {
        const query = route.query && route.query.q ? route.query.q : null;
        await store.dispatch(SET_QUERY_ACTION, query);

        await store.dispatch(FETCH_FILTERS);
        let region = null;
        if (route.params.region && route.params.region !== "alla") {
          region = store.getters[GET_REGION_BY_NAME](route.params.region);
        }

        await store.dispatch(SET_REGION_ACTION, region);

        let category = null;
        if (route.params.category) {
            category = store.getters[GET_CATEGORY_BY_NAME](
                route.params.category
            );
        }

        await store.dispatch(SET_CATEGORY_ACTION, category);

        return store.dispatch(FETCH_COMPANIES);
    },

    components: {
        SiteHeader,
        SiteFooter,
        SearchHeader,
        SearchResults,
        SearchSidebar,
        ButtonAtom,
        Pagination
    },
    computed: {
        ...mapGetters({
            getRegionByName: GET_REGION_BY_NAME,
            getCategoryByName: GET_CATEGORY_BY_NAME,
            searchParams: GET_SEARCH_PARAMS,
            getRegion: GET_REGION,
            getCategory: GET_CATEGORY,
            getSeachTitle: GET_FACET_TITLE,
            getSeachContent: GET_FACET_CONTENT,
            getFullContent: GET_FACET_FULL_CONTENT
        }),
        paramRegion: {
          get(){
            return !!this.$route.params.region
          }
        },
        title: {
            get() {
                if (this.getSeachTitle) {
                    return this.getSeachTitle;
                }

                const categoryText =
                    this.getCategory && this.getCategory.Name
                        ? this.getCategory.Name
                        : "Medlemsföretag";
                const regionText =
                    this.getRegion && this.getRegion.Name
                        ? " i " + this.getRegion.Name
                        : "";

                return `${categoryText}${regionText}`;
            }
        },
        seotitle: {
            get() {
                if (
                    this.getFullContent &&
                    this.getFullContent["bb_seo_title"]
                ) {
                    return this.getFullContent["bb_seo_title"];
                }
                if (this.getSeachTitle) {
                    return this.getSeachTitle;
                }
                const categoryText =
                    this.getCategory && this.getCategory.Name
                        ? this.getCategory.Name
                        : "Medlemsföretag";
                const regionText =
                    this.getRegion && this.getRegion.Name
                        ? " i " + this.getRegion.Name
                        : "";

                return `${categoryText}${regionText}`;
            }
        },
        information: {
            get() {
                return (
                    this.getSeachContent ||
                    "BraByggare är en kostnadsfri tjänst där du tryggt och enkelt får tag på  kvalitetssäkrade hantverkare för ditt projekt. Skapa en förfrågan, beskriv vad du behöver hjälp med – så får du snabbt svar."
                );
            }
        },
        metaDesc: {
            get() {
                if (this.getFullContent && this.getFullContent["bb_seo_desc"]) {
                    return this.getFullContent["bb_seo_desc"];
                }
                return this.information.replace(/<[^>]*>?/gm, "").trim();
            }
        }
    },
    methods: {
        ...mapActions({
            fetchCompanies: FETCH_COMPANIES,
            fetchFilters: FETCH_FILTERS,
            setRegion: SET_REGION_ACTION,
            setCategory: SET_CATEGORY_ACTION
        })
    },

    metaData() {
        return {
            title: this.seotitle,
            meta: [
                {
                    vmid: "description",
                    name: "description",
                    content: this.metaDesc
                }
            ],
            link: [
                {
                    rel: "canonical",
                    href: `${process.env.SITE_BASE_URL}${this.$route.path}`
                }
            ]
        };
    },
    watch: {
        $route(to) {
            setFacetsFromURL(this.$store, to);
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/views/Companies-facet.vue